import React, { useState } from 'react'
import { useQuery } from '@cedarjs/web'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  IconButton,
  Collapse,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { INTEGRATIONS_QUERY } from 'src/pages/AdminIntegrationsPage/queries/integrations'

const IntegrationsList = () => {
  const { data, loading, error } = useQuery(INTEGRATIONS_QUERY)
  const [expanded, setExpanded] = useState<string | null>(null)

  if (loading) {
    return <Typography>Loading integrations...</Typography>
  }

  if (error) {
    return (
      <Typography color="error">
        Error loading integrations: {error.message}
      </Typography>
    )
  }

  if (!data?.integrations) {
    return <Typography>No integrations found.</Typography>
  }

  return (
    <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 1 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Integration</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Operations</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.integrations.map((integration) => (
            <React.Fragment key={integration.id}>
              <TableRow hover>
                <TableCell>
                  <Typography fontWeight={500}>
                    {integration.displayName || integration.name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {integration.description}
                  </Typography>
                </TableCell>
                <TableCell>
                  <IconButton
                    size="small"
                    onClick={() =>
                      setExpanded(
                        expanded === integration.id ? null : integration.id
                      )
                    }
                  >
                    {expanded === integration.id ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </IconButton>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={3} sx={{ p: 0, border: 0 }}>
                  <Collapse
                    in={expanded === integration.id}
                    timeout="auto"
                    unmountOnExit
                  >
                    <Box sx={{ pl: 4, py: 1 }}>
                      {integration.IntegrationOperation.length === 0 ? (
                        <Typography variant="body2" color="text.secondary">
                          No operations
                        </Typography>
                      ) : (
                        <ul style={{ margin: 0, paddingLeft: 16 }}>
                          {integration.IntegrationOperation.map((op) => (
                            <li key={op.id}>
                              <Typography variant="body2">
                                <b>{op.operationName}</b>
                                {op.description ? ` — ${op.description}` : ''}
                              </Typography>
                            </li>
                          ))}
                        </ul>
                      )}
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default IntegrationsList
